<button
  class="prev-results-btn"
  type="button"
  (click)="handleClick()"
  [disabled]="!count"
>
  <div class="count">{{count}}</div>
  {{'assignment.VIEW_PREVIOUS_RESULTS' | transloco}}
  <qai-icon kind="arrow-up-right" class="icon" />
</button>
